
// ---------------------------------------------------------------------------------------------------- \\
// --------------------------------------------- GUIDE TYPE ------------------------------------------- \\
// ---------------------------------------------------------------------------------------------------- \\

export enum EGuideType {
    TECHNICAL = 'TECHNICAL',
    PEDAGOGICAL = 'PEDAGOGICAL',
}
